export const data=[
    {
        name:"New Search",
        component:"News",
        route:"/newsapp",
        description:'A news-search websapp which displays MOST VIEWED Article from NewYork Times using an API'
    },
    {
        name:"Incrementer App ",
        component:"Incrementer",
        route:"/incrementer",
        description:"This app display a increment decrement which can be used for an ecommerce site"
    },
    {
        name:"2048 Game",
        component:"Game",
        route:"/game",
        description:"This is 2048 game. Play and enjoy the game"
    },
    {
        name:"Clock",
        component:"Clock",
        route:"/clock",
        description:"Beautiful Clock App which changes background and format of clock on click. "

    },
    {
        name:"Jokes App",
        component:"Jokes",
        route:"/jokesapp",
        description:"Generate Random Dad Jokes from 'RapidAPI dad joke's api'"  
    },
    {
        name:"Box Shadow Generator",
        component:"BoxShadow",
        route:"/boxshadowgenerator",
        description:"Generate Box Shadow by using different range inputs"
    },
    {
        name:"Todo App",
        component:"Todo",
        route:"/todo",
        description:"Make a todo list using django rest framework"
    },
    {
        name:"Slot Machine Game",
        component:"SlotM",
        route:"/slotmachinegame",
        description:"Play the game and try your luck, to see if you can win."
    }
    // {
    //     name:"Music System",
    //     component:"MusicSystem",
    //     route:"/musicsystem",
    //     description:"A collaborative music app using spotify api"
    // }
]